import { javascript } from '@codemirror/lang-javascript';
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Injectable } from '@angular/core';
import { FileUploadService } from 'src/app/shared/services/file-upload.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';

import { GptChatModelTypeArr } from '@shared/index';
import { ProjectSecretService } from 'src/app/shared/services/project-secret.service';
import { BlocklyHelperService } from './blockly-helper.service';
import { BLOCKLY_DUMMY, BlocklyToolboxCategory } from './blocky-types.types';

@Injectable({
  providedIn: 'root'
})
export class BlockkyPlaygroundService {
  constructor(
    private BH: BlocklyHelperService,
    private stageAdmin: StageAdminService,
    private files: FileUploadService,
    private rss: RouteShareService,
    private projectSecretService: ProjectSecretService
  ) { }


  public getStackProcessItems(): { checkType: string, text: string, options: string[] }[] {
    return [
      { checkType: 'IMAGE', text: 'Bild', options: this.rss._allImageSkills() },
      { checkType: 'DOCUMENT', text: 'Dokument', options: this.rss._allDokuments() },
      { checkType: 'WEBHOOK', text: 'Webbhook', options: this.rss._allWebhooks() },
      { checkType: 'DATABASE', text: 'Datenbank', options: this.rss._allDataBases() },
      { checkType: 'WENNDANN', text: 'Wenn-Dann', options: this.rss._allWennDann() },
      { checkType: 'ONLINESOURCE', text: 'Onlinequellen', options: this.rss._allOnlineSources() },
      { checkType: 'OFFLINEWEBSITE', text: 'Offline-Websites', options: this.rss._allOfflineWebsites() }
    ];
  }



  public playgroundBlocks(name: string = "unnamed"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [];




    cat.contents.push(
      this.BH._custom("RAG_RAW", "🌀 javascript: {{code:text}}", "{{code!}}", { colour: '#000000' })
    );
    cat.contents.push(
      this.BH._custom("RAG_RAW_OUTPUT", "@output:String\n 🌀 javascript: {{code:text}}", "{{code!}}", { colour: '#000000' })
    );


    //FASTEST BOT ALIVE


    //DOCSEARCH
    cat.contents.push(


    );

    //EXTRAS







    //KeyVal


    return cat;
  }

}

